// Logo MutationObserver - runs after DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  const observer = new MutationObserver((mutationsList, observer) => {
    const logoImg = document.querySelector('img[src*="21d9b9ad-8f62-4c32-aa0a-245f277eb917.jpeg"]');
    if (logoImg) {
      logoImg.setAttribute("width", "100");
      logoImg.setAttribute("height", "50"); // Use correct height
      observer.disconnect(); // Stop observing once it's found and updated
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});